import { render, staticRenderFns } from "./FirstName.vue?vue&type=template&id=7fef6505&scoped=true"
import script from "./FirstName.vue?vue&type=script&lang=js"
export * from "./FirstName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef6505",
  null
  
)

export default component.exports